import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  InboxOutlined,
  ScanOutlined,
  ExportOutlined,
  RiseOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <InboxOutlined />,
  1: <ScanOutlined />,
  2: <ExportOutlined />,
  3: <AppstoreOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("wms");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-wms-section dev-wms-benefits-section">
      <div className="dev-wms-section-inner">
        <h2 className="dev-section-h2 dev-wms-section-h2">
          <span className="dev-wms-section-h2-icon dev-wms-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-wms-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-wms-benefit-card">
              <div className="dev-wms-benefit-left">
                <span className="dev-wms-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-wms-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-wms-benefit-body">
                <div className="dev-wms-benefit-title">{item.title}</div>
                <div className="dev-wms-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
